import React from "react";
import { CheckCircle2 } from "lucide-react";
import { whyPublish } from "../content/landingContent";
import { Reveal } from "./Reveal";
import { useContentField, useContentList } from "../lib/useContent";

export const WhyPublish: React.FC = () => {
  const title = useContentField("whyPublish.title", whyPublish.title);
  const benefits = useContentList("whyPublish.benefitsList", whyPublish.benefits);
  const closing = useContentField("whyPublish.closing", whyPublish.closing);
  return (
    <section
      id="beneficios"
      data-testid="why-publish-section"
      className="bg-motor-mist py-20 sm:py-24 lg:py-28"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-2xl">
          <span className="font-display text-xs font-semibold uppercase tracking-[0.2em] text-motor-red">
            Capítulo 05
          </span>
          <h2 className="mt-4 font-display font-bold text-3xl sm:text-4xl lg:text-[2.75rem] text-motor-ink leading-tight">
            {title}
          </h2>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-2 gap-4">
          {benefits.map((benefit, idx) => (
            <Reveal key={idx} delay={idx * 0.05}>
              <div
                data-testid={`why-publish-benefit-${idx}`}
                className="flex items-start gap-3 rounded-xl bg-white border border-neutral-200 p-4"
              >
                <CheckCircle2 className="h-5 w-5 text-motor-red shrink-0 mt-0.5" />
                <span className="text-sm sm:text-base text-neutral-700">{benefit}</span>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.3} className="mt-10">
          <div className="rounded-2xl border-l-4 border-motor-red bg-white p-6 sm:p-8">
            <p className="text-base sm:text-lg font-display font-medium text-motor-ink leading-relaxed">
              {closing}
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
